import React from 'react'
import './TrioCards.scss'
import { useSelector } from 'react-redux'
import { connectTrio } from '../../Trio.connect'
import { useParams } from 'react-router-dom'
import RoundTimer from '../../../helpers/RoundTimer/RoundTimer'


const TrioCards = ({ exchangeGames }) => {

  const cardSrc = (card) => {
    if (card) {
      return `https://stream.fawk.app/assets/smallCards/${card}.png`
    } else {
      return `https://stream.fawk.app/assets/smallCards/BACK.png`
    }
  }
      return (
        <div className="trioCardsContent">
          <div className="trioCardsContent-total">
            <div className="trioCardsContent-total__cards">
              <img
                className="trioCardsContent-total__cards-card"
                src={cardSrc(
                    exchangeGames && exchangeGames[0]?.indexCard[0]
                )}
                alt=""
              />
              <img
                className="trioCardsContent-total__cards-card"
                src={cardSrc(
                    exchangeGames && exchangeGames[0]?.indexCard[1]
                )}
                alt=""
              />
              <img
                className="trioCardsContent-total__cards-card"
                src={cardSrc(
                    exchangeGames && exchangeGames[0]?.indexCard[2]
                )}
                alt=""
              />
            </div>
          </div>
        </div>
      )
  }


export default connectTrio()(TrioCards)
